/**
 * Format duration in microseconds to human-readable string
 * @param microseconds Duration in microseconds
 * @returns Formatted duration string (e.g., "1.2ms", "45.3s", "2.1m")
 */
export function formatDuration(microseconds: number): string {
  if (microseconds < 1000) {
    return `${microseconds.toFixed(0)}μs`;
  }

  const milliseconds = microseconds / 1000;
  if (milliseconds < 1000) {
    return `${milliseconds.toFixed(1)}ms`;
  }

  const seconds = milliseconds / 1000;
  if (seconds < 60) {
    return `${seconds.toFixed(2)}s`;
  }

  const minutes = seconds / 60;
  if (minutes < 60) {
    return `${minutes.toFixed(2)}m`;
  }

  const hours = minutes / 60;
  return `${hours.toFixed(2)}h`;
}

/**
 * Format timestamp (Unix epoch in microseconds) to time only string
 * @param microseconds Timestamp in microseconds
 * @returns Formatted time string (e.g., "10:19:11 PM")
 */
export function formatTimeOnly(microseconds: number): string {
  const milliseconds = microseconds / 1000;
  return new Date(milliseconds).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}

/**
 * Get a color class based on span duration for visual indication
 * @param durationMs Duration in milliseconds
 */
export function getDurationColorClass(durationMs: number): string {
  if (durationMs < 100) return 'text-green-600 dark:text-green-400';
  if (durationMs < 500) return 'text-yellow-600 dark:text-yellow-400';
  if (durationMs < 2000) return 'text-orange-600 dark:text-orange-400';
  return 'text-red-600 dark:text-red-400';
}
